import React, { FC } from 'react';
import styled from '@emotion/styled';
import startAConversationArt from '../assets/start-a-conversation.svg';
import { HeadingText40, pxToRem } from '@modernhealth/vital-components';
import { useTranslation } from 'react-i18next';
import { Conversation } from 'src/shared/messaging-kit/types';

export const StartAConversation: FC<{ coach: Conversation['coach'] }> = ({ coach }) => {
    const { t } = useTranslation();
    return (
        <StyledStartAConversationContainer>
            <StyledImageContainer>
                <img
                    src={startAConversationArt}
                    height={127}
                    alt={t('messaging:conversation.list.no_messages.title', {
                        name: coach?.firstName,
                    })}
                    aria-hidden="true"
                />
            </StyledImageContainer>
            <StyledHeadingText>
                {t('messaging:conversation.list.no_messages.title', { name: coach?.firstName })}
            </StyledHeadingText>
            <StyledDescriptionText>
                {t('messaging:conversation.list.no_messages.description', {
                    name: coach?.firstName,
                })}
            </StyledDescriptionText>
        </StyledStartAConversationContainer>
    );
};

const StyledStartAConversationContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

const StyledImageContainer = styled.div`
    margin-bottom: ${pxToRem(20)};
`;

const StyledHeadingText = styled(HeadingText40)`
    padding: ${pxToRem(5)};
    margin-bottom: 0;
`;

const StyledDescriptionText = styled.p`
    width: 50%;
    text-align: center;
`;
